<template>
  <div class="box">
    <Header :active="active" />
    <Banner />
    <div class="list">
      <div class="inner">
        <div class="publictitle">
          <p class="pli">徐凯文专栏</p>
          <!-- <p class="pli1">Kevin Xu column</p> -->
        </div>
        <!-- <img class="publicimg" src="../assets/images/1.png" alt="" /> -->
        <div class="forlist clearfix">
          <div
            @click="goXu(item)"
            v-for="(item, index) in list"
            :key="index"
            class="for"
          >
            <img :src="item.cover" alt="" />
            <p class="bold">{{ item.title }}</p>
            <div class="content">
              {{ item.fabuTime }}
            </div>
          </div>
        </div>
        <div class="pages">
          <el-pagination
            @current-change="loadData"
            layout="prev, pager, next"
            :page-count="size"
            :current-page="page"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <Map ref="map" />
    <Foot />
    <Right />
  </div>
</template>

<script>
import Right from "../components/Right.vue";
import Header from "../components/header.vue";
import Banner from "../components/banner.vue";
import Map from "../components/map.vue";
export default {
  components: {
    Header,
    Right,
    Map,
    Banner,
  },
  data() {
    return {
      active: 3,
      page: 1,
      size: 1,
      list: [],
    };
  },
  computed: {},
  mounted() {
    document.documentElement.scrollTop = 0;
    this.getList();
  },
  beforeDestroy() {
    this.$refs.map.destroy();
  },
  methods: {
    getList() {
      var data = {
        limit: 9,
        page: this.page,
        type: 0,
      };
      this.$get("/web/api/list_article", data).then((res) => {
        if (res.code == 200) {
          this.size = res.data.size;
          this.list = res.data.list;
        }
      });
    },
    loadData(e) {
      this.page = e;
      this.getList();
    },
    goXu(item) {
      sessionStorage.setItem("xu", JSON.stringify(item));
      this.$router.push(`/xuinner`);
    },
  },
};
</script>

<style  scoped>
.publicimg {
  margin: 0 auto 30px;
  display: block;
}
.six {
  padding: 50px 0;
  background-color: #eff9f8;
}
.seven {
  padding: 50px 0;
}
.imglist img {
  display: block;
  width: 230px;
  height: 107px;
  margin-right: 20px;
  float: left;
  margin-bottom: 20px;
}
.imglist > img:nth-child(5n) {
  margin-right: 0;
}
.foot {
  line-height: 50px;
  background-color: #898989;
  text-align: center;
  color: #fff;
}
.list {
  padding: 25px 0 50px 0;
}
.titles {
  color: #2c87ce;
}
.for {
  width: 390px;
  box-sizing: border-box;
  border: 1px solid #e4e4e4;
  cursor: pointer;
  float: left;
  margin-bottom: 30px;
  margin-right: 30px;
}
.forlist > .for:nth-child(3n) {
  margin-right: 0;
}
.for img {
  display: block;
  width: 100%;
  height: 250px;
}
.bold {
  font-weight: bold;
  line-height: 42px;
  padding: 0 10px;
}
.content {
  padding: 0 10px 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #6d6d6d;
  font-size: 14px;
}
.pages {
  display: flex;
  justify-content: center;
}
.liucheng {
  display: block;
  width: 1020px;
  margin: 0 auto;
}
</style>